export const locales = [
  // { code: 'es', iso: 'es-ES', file: 'es.js', name: 'Español', flag: 'mx' },
  // { code: 'fr', iso: 'en-FR', file: 'fr.js', name: 'Français', flag: 'fr' },
  { code: 'en', iso: 'en-US', file: 'en.js', name: 'English', flag: 'us' },
]
